/*用于富文本编辑器图片路径前缀的截取与拼接*/

const baseURL = "/fxxfzsd-api"
const downloadUrl = baseURL + '/api/common/download/resource?name='

//去掉前缀： 截取掉src中/profile之前的内容
export function cutPrefix(content){
    if (content === '' || content === undefined || content === null){
        return content
    }
    return content.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gmi, function (match, capture) {
        // 拿到当前的单个img标签
        // console.log(match);
        // 拿到当前img标签内的src地址
        // console.log(capture);
        // i 不区分大小写
        let str = capture.replace(/(\S*)name=/i,'');
        return `<img src="${str}">`
    });
}

//加上前缀： 添加src中/profile之前的内容
export function joinPrefix(content){
    if (content === '' || content === undefined || content === null){
        return content
    }
    return content.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gmi, function (match, capture) {
        // 拿到当前的单个img标签
        // console.log(match);
        // 拿到当前img标签内的src地址
        // console.log(capture);
        // i 不区分大小写
        let str =  downloadUrl + capture;
        return `<img src="${str}" style="max-width: 100%">`
    });
}

function test() {
    //js截取某个字符串前面的内容：
    var str = "aaabbbcccdddeeefff";
    str = str.match(/(\S*)fff/)[1];
    alert(str);//结果aaabbbcccddd

    // js截取某个字符串后面的内容：
    var str = "aaabbbcccdddeeefff";
    str = str.match(/aaa(\S*)/)[1];
    alert(str);//结果bbbcccdddeeefff
}